/**
 * 用户系统拓展模块，负责和用户系统没有直接关系的功能，如第三方判断，增加书签，页面跳转等附属功能
 *
 * @author mingxin.huang
 * @update 2013.08.21
 */

$.module('MM.user.extraController', function () {
  var LOGIN_LOG_TAG = 'LOGIN_DATE'; //之前一次登录的时间

  var _actions = {
    loginLog: 'user/day_login/{access_token}?p=4',
    checkname: MM.core.getRoot('register/checkname?userName={userName}', 'user'),
    send_mobile_new: MM.core.getRoot(
      'authcode/new_send_mobile?mobile={mobile}&type=1&code=destsaz' +
        Math.floor(Math.random() * 100),
      'user',
    ),
    getImgCode: MM.core.getRoot('authcode/sendsms_captcha', 'user'),
    checkname_mobile: MM.core.getRoot('register/checkmobile?mobile={mobile}', 'user'),
    bind_email: 'user/bind_email/{access_token}?email={email}',

    complete_mobile_info:
      'user/complete_mobile_info?access_token={access_token}&mobile={mobile}&sms_code={sms_code}',
    bindMobile: 'user/bind_mobile/{access_token}?mobile={mobile}&sms_code={sms_code}',

    sina: 'https://api.weibo.com/oauth2/authorize?scope=follow_app_official_microblog&client_id=3338801716&display=default&redirect_uri={redirect_uri}&state={state}',
    // sina:'https://api.weibo.com/oauth2/authorize?client_id=3338801716&response_type=code&&redirect_uri=test-user.memeyule.com/thirdlogin/sina',
    // sina:'https://api.weibo.com/oauth2/authorize?scope=follow_app_official_microblog&forcelogin=true&client_id=3338801716&redirect_uri=test-user.memeyule.com/thirdlogin/sina',
    qq: 'https://graph.qq.com/oauth2.0/authorize?scope=upload_pic,add_topic,get_user_info&client_id=101118713&response_type=code&redirect_uri={redirect_uri}',
    weixin_pc:
      'https://open.weixin.qq.com/connect/qrconnect?appid=wxcd8011dbaf7a24ca&redirect_uri={redirect_uri}&response_type=code&scope=snsapi_login&state=1#wechat_redirect',
    weixin_pc_test:
      'https://open.weixin.qq.com/connect/qrconnect?appid=wx8120ce5a486794d7&redirect_uri={redirect_uri}&response_type=code&scope=snsapi_login&state=1#wechat_redirect',
    realname:
      '/user/real_id_auth?access_token={access_token}&real_name={real_name}&id_card_type={id_card_type}&id_card_num={id_card_num}',
  };

  function _init() {
    _getFrom();
    _getSubFrom();
    _initMEME_UID();
  }

  function _initMEME_UID() {
    var uid = MM.common.getCookie('MEME_UID');
    if (!uid) {
      MM.common.setCookie('MEME_UID', new Date().getTime(), 1000 * 60 * 60 * 24 * 365 * 2);
    }
  }

  // 获取用户来源
  function _getFrom() {
    //确定来源
    var _from = $.query.get('from');

    if (!_from) {
      _from = MM.common.getCookie('from') || 'MM';
    }

    _from += '';

    _from = _from.replace(/_h5$/i, '');

    MM.common.setCookie('from', _from);

    return _from;
  }

  // 获取用户子来源
  function _getSubFrom() {
    var _from = $.query.get('sid');
    if (_from === undefined) {
      _from = MM.common.getCookie('subfrom');
    }
    _from += '';
    if (!_from.length) {
      _from = '';
    }
    MM.common.setCookie('subfrom', _from);
    return _from;
  }

  /**
   * 登录跳转
   * @param       {String}  type        [type 跳转的类型(qq/sina/weixin_pc)]
   * @param       {Boolean} isNewWindow      [是否打开新窗口]
   * @param       {String}  target_live [回跳到固定地址]
   * @constructor
   */
  function _redirectToLogin(type, isNewWindow, target_live) {
    var action = _actions[type];
    if (type == 'weixin_pc' && !MM.config.isRelease()) {
      action = _actions['weixin_pc_test'];
    }

    var back_url = location.href;
    if (!$.browser.msie && !MM.core.isMobile()) {
      back_url = MM.common.getHttpType() + location.host + '/result.html';
    }
    var temp = back_url.split('#');

    if (target_live) {
      back_url = encodeURIComponent(
        temp[0] +
          (temp[0].indexOf('?') > -1 ? '&' : '?') +
          'access_token={access_token}&target_live=' +
          target_live,
      );

      back_url += temp.length > 1 ? '#' + temp[1] : '';
    } else {
      back_url = encodeURIComponent(
        temp[0] + (temp[0].indexOf('?') > -1 ? '&' : '?') + 'access_token={access_token}',
      );
      back_url += temp.length > 1 ? '#' + temp[1] : '';
    }

    // 上报事件
    var seqid = MM.util.sdata.trackWithSeqId('third_login', {
      logintype: type,
    });
    var url = $.formatByVal(action, {
      redirect_uri: encodeURIComponent(
        MM.core.getRoot(
          'thirdlogin/' + type + '?event_seq_id=' + seqid + '&url=' + back_url,
          'user',
        ),
      ),
    });

    if (!$.browser.msie && !MM.core.isMobile() && !isNewWindow) {
      var win = null;
      if (type == 'sina') {
        url = $.formatByVal(action, {
          redirect_uri: encodeURIComponent(MM.core.getRoot('thirdlogin/' + type, 'user')),
          // redirect_uri: encodeURIComponent(MM.core.getRoot('thirdlogin/' + type + '?event_seq_id='+ seqid, 'user')),
          state: MM.common.getHttpType() + location.host + '/result.html',
        });
        win = MM.ui.base.openWindow(url, 760, 572);
        if (win && win.focus) {
          win.focus();
        }
        return;
      }
      win = MM.ui.base.openWindow(url, 650, 640);
      if (win && win.focus) {
        win.focus();
      }
    } else {
      return (location.href = url);
    }
  }

  // 跳转至签约页面
  function _redirectToApply() {
    if (!MM.user.isLogin()) {
      MM.user.popupLogin();
    } else {
      var win = MM.ui.base.openWindow('/apply');
      win.focus();
    }
  }

  /**
   * 跳转到充值页
   * @param  {Boolean} isCurr 是否本页面打开
   */
  function _redirectToCharge(channel, roomId) {
    MM.common.redirectPay();

    // MM.core.debug('_redirectToCharge');
    // if (!MM.user.isLogin()) {
    //   MM.user.popupLogin();
    // } else {
    //   if (typeof channel != 'undefined') {
    //     sa.track('recharge', {
    //       pay_channel: channel || '',
    //       roomId: (roomId || 0) + '',
    //     });
    //   }
    //   if (top !== self) {
    //     return parent.MM.user.redirectToCharge();
    //   }
    //   if (!$.os.desktop) {
    //     //  兼容手机，用 $.os.meme 判断 还不成熟。2016-08-17 10:52:19 fulh
    //     window.location.href = 'mmshow-pay://com.sds.android.ttshow';
    //   } else {
    //     var win = MM.ui.base.openWindow('/pay.html');
    //     win.focus();
    //   }
    // }
  }

  var _usernameReg = /^\w+$/,
    _engReg = /[a-zA-Z_]+/,
    _chineseReg = /[\u4E00-\u9FA5]+/,
    _mobileReg = /^1\d{10}$/,
    _codeReg = /^\d{6}$/;

  /**
   * 判断输入的用户名是否合法
   * @param  {String} userName 用户名
   * @return {String}          错误提示
   */
  function _checkUserName(userName) {
    userName = $.trim(userName);

    var errorTip = '';

    if (_chineseReg.test(userName)) {
      errorTip = '用户名不能为中文';
    } else if (userName.length === 0) {
      errorTip = '请填写用户名';
    } else if (userName.length < 6) {
      errorTip = '用户名太短';
    } else if (userName.length > 14) {
      errorTip = '用户名太长';
    } else {
      if (!_engReg.test(userName)) {
        errorTip = '用户名不能为纯数字';
      } else if (!_usernameReg.test(userName)) {
        errorTip = '用户名不能有特殊字符';
      }
    }

    return errorTip;
  }

  /**
   * 判断手机号是否合法
   * @param  {String} phoneNum 手机号
   * @return {String}          错误提示
   */

  function _checkMobileNum(mobileNum) {
    mobileNum = $.trim(mobileNum);

    var errorTip = '';
    if (mobileNum.length === 0) {
      errorTip = '请填写手机号';
    } else if (!_mobileReg.test(mobileNum)) {
      errorTip = '请输入正确的手机号';
    }
    return errorTip;
  }

  /**
   * 判断验证码
   */
  function _checkCodeNum(CodeNum) {
    CodeNum = $.trim(CodeNum);

    var errorTip = '';
    if (CodeNum.length === 0) {
      errorTip = '请填写验证码';
    } else if (!_codeReg.test(CodeNum)) {
      errorTip = '请输入6位验证码';
    }

    return errorTip;
  }

  /**
   * 检查用户名是否重复
   * @param  {String} userName        用户名
   * @param  {Function} successCallback 验证通过回调
   * @param  {Function} errorCallback   验证没通过回调
   */
  function _checkNameRepeat(userName, successCallback, errorCallback) {
    MM.core.getResult({
      url: _actions.checkname,
      data: {
        userName: userName,
      },
      success: function (res) {
        if ($.isFunction(successCallback)) {
          successCallback();
        }
      },
      resolveError: function (res) {
        if (res.code === 30408 && $.isFunction(errorCallback)) {
          errorCallback();
        }
      },
    });
  }

  /**
   * [_checkMobileRepeat 检查手机号是否重复]
   * @param  {[string]} userName        [用户名（手机号）]
   * @param  {[function]} successCallback [验证通过回调]
   * @param  {[function]} errorCallback   [验证没通过回调]
   *
   */
  function _checkMobileRepeat(mobile, successCallback, errorCallback) {
    MM.core.getResult({
      url: _actions.checkname_mobile,
      data: {
        mobile: mobile,
      },
      success: function (res) {
        if ($.isFunction(successCallback)) {
          flag = true;
          successCallback();
        }
      },
      resolveError: function (res) {
        if (res.code === 30433 && $.isFunction(errorCallback)) {
          flag = false;
          errorCallback();
        }
      },
    });
  }

  /**
   * 检查密码
   * @param  {String} pwd 密码
   * @return {String}     提示
   */
  function _checkPwd(pwd) {
    var errorTip = '';

    if (typeof pwd == 'string') {
      if (pwd.length === 0) {
        errorTip = '请填写密码';
      } else if (pwd.length < 8) {
        errorTip = '密码必须最少为8位';
      } else if (pwd.length > 20) {
        errorTip = '密码必须最大为20位';
      } else if (!/^(?![0-9a-z]+$)(?![a-zA-Z]+$)(?![0-9A-Z]+$)[0-9A-Za-z]{8,20}$/.test(pwd)) {
        errorTip = '密码需同时包含小写字母，大写字母和数字';
      }
    }
    return errorTip;
  }

  /**
   * 检查密码和确认密码
   * @param  {String} cPwd 确认密码
   * @param  {String} pwd  密码
   * @return {String}      提示
   */
  function _checkConfirmPwd(cPwd, pwd) {
    var errorTip = '';

    if (cPwd.length === 0) {
      errorTip = '请输入确认密码';
    } else if (cPwd !== pwd) {
      errorTip = '确认密码和密码不一致';
    }

    return errorTip;
  }

  // 发送登录日志
  function _sendLoginLog() {
    var date = MM.common.formatTime(Date.now(), 'yyyyMMdd'),
      lastDateData = $.store.get(LOGIN_LOG_TAG) || {},
      userInfo = MM.user.getUserInfo();

    if (!lastDateData || date != lastDateData[userInfo._id]) {
      lastDateData[userInfo._id] = date;

      MM.log.send({
        event: 'day_login',
        desc: '每日登录',
        content: {
          user_id: userInfo._id,
          nick_name: userInfo.nick_name,
        },
      });

      MM.core.getResult({
        url: _actions.loginLog,
        requireToken: true,
        success: function (res) {
          $.store.set(LOGIN_LOG_TAG, lastDateData);
        },
      });

      // request.send({
      //   url: 'https://api.map.baidu.com/location/ip?ak=aqMigZp0k9MclnwAgoQNeiSA2HgI2IZi&coor=bd09ll',
      //   dataType: 'jsonp',
      //   success: function (res) {
      //     var point = _.get(res, 'data.content.point', { x: 0, y: 0 });
      //     sa.track('longitude_latitude_log', {
      //       longitude_x: parseFloat(point.x),
      //       longitude_y: parseFloat(point.y),
      //     });
      //   },
      //   error: function () {},
      // });
    }
  }

  // 绑定邮箱
  function _popupBindEmail() {
    MM.ui.popup.show({
      id: 'popup-bind-email',
      title: '绑定邮箱',
      width: 300,
      center: true,
      disableMsk: true,
      content:
        '\
            <div>\
                <div style="padding:0 0 10px;">填写邮箱地址：</div>\
                <div><input id="j_email" type="text" name="email" class="form-input" style="width:250px;"/></div>\
                <div class="error-tip text-danger"></div>\
            </div>\
            ',
      footer: '<a href="javascript:void(0);" class="btn btn-lg btn-w8 btn-success">确定</a>',
      appendCallback: function ($selector) {
        $selector.find('.popup-close').hide();

        var $tip = $selector.find('.error-tip');
        var $input = $selector.find('#j_email').blur(function () {
          var val = $.trim($input.val()),
            tip = '';
          if (val.length === 0) {
            tip = '请填写邮箱';
          } else if (!/^[a-z\d]+(\.[a-z\d]+)*@([\da-z](-[\da-z])?)+(\.{1,2}[a-z]+)+$/.test(val)) {
            tip = '邮箱格式错误';
          }
          $tip.text(tip);
        });
        $selector.find('.btn-success').click(function () {
          var val = $.trim($input.val());
          $input.blur();
          if ($tip.text().length) {
            return;
          }

          MM.core.getResult({
            url: _actions.bind_email,
            data: {
              email: val,
            },
            success: function (res) {
              MM.ui.messager.success('绑定成功', function () {
                location.reload();
              });
              MM.ui.popup.hide();
            },
            resolveError: function (res) {
              var msg = {
                30414: '邮箱已经存在',
                30415: '邮箱格式错误',
                30425: '账号已经绑定过邮箱',
              };
              $tip.text(msg[res.code] || '绑定异常');
            },
          });
        });
      },
    });
  }

  function _showCommonCheckMobile(options) {
    var id = 'common-check-mobile-popup';
    var popupOpts = _.assign(
      {
        id: id,
        newUi: true,
        width: 360,
        center: true,
        content:
          '<form><div class="common-mobile-content"></div>\
                <div class="ui-form-item"><div class="ui-form-tip error-tip"></div></div>\
                <div class="ui-form-item-submit"><div class="ui-form-btn submit-btn">提交</div></div>\
            </form>',
      },
      options,
    );

    popupOpts.appendCallback = function ($popup) {
      var $errorTip = $popup.find('.error-tip');
      MM.ui.smscode.render(
        _.assign(
          {
            $wrapper: '#' + id + ' .common-mobile-content',
            $errorTip: '#' + id + ' .error-tip',
            $submitBtn: '#' + id + ' .submit-btn',
            checkRepeat: false,
            onSubmit: function (data) {
              options.onSubmit({
                source: data,
                $errorTip: $errorTip,
              });
            },
          },
          options.smsProps,
        ),
      );
    };

    MM.ui.popup.show(popupOpts);
  }

  // 绑定手机信息
  // options.disableReload  设置绑定手机成功后是否刷新页面
  function _showBindMobilePopup(options) {
    var errormsg = {
      30412: '余额不足',
      30432: '手机号格式错误',
      30431: '短信验证码无效',
      30433: '该手机号已绑定其他么么号，请更换手机号',
      30435: '短信验证间隔太短',
      30437: '短信验证码每日次数超过限制',
      30419: '发送短信需填写验证码',
      110110: '该手机号因违规无法继续使用，请重新更换手机号',
      30250: '这是一个bug，反正我是信了', //测试主播改密码
    };

    var checkMobileProps = _.assign(
      {
        title: '绑定手机号',
        classes: 'safety-popup',
        smsProps: {
          checkRepeat: true,
        },
      },
      options,
    );

    checkMobileProps.onSubmit = function (props) {
      var $errorTip = props.$errorTip;
      MM.core.getResult({
        url: _actions.bindMobile,
        data: props.source,
        success: function () {
          MM.ui.popup.showSuccess({
            title: '绑定手机号',
            tipTitle: '手机号绑定成功!',
            duration: 2000,
            okBtnText: '确定',
            callback: function () {
              !checkMobileProps.disableReload && location.reload();
              if (checkMobileProps.successCallback) {
                checkMobileProps.successCallback();
              }
            },
          });
        },
        resolveError: function (res) {
          $errorTip.text(errormsg[res.code] || res.message || '手机号码绑定失败');
        },
      });
    };

    _showCommonCheckMobile(checkMobileProps);
  }

  /**
   * 实名认证
   */
  function _handleRealNamePopup() {
    var _realNameTmpl =
      '\
        <form>\
            <div class="ui-form-item"><input class="ui-form-input" type="text" value="" name="real_name" placeholder="真实姓名"/></div>\
            <div class="ui-form-item user-card-type"></div>\
            <div class="ui-form-item"><input class="ui-form-input" type="text" value="" name="id_card_num" placeholder="证件号码"/></div>\
            <div class="ui-form-item"><div class="ui-form-tip error-tip"></div></div>\
            <div class="ui-form-item-submit"><div class="ui-form-btn">立即认证</div></div>\
        </form>\
        ';
    var options = {
      newUi: true,
      id: 'change-pwd-popup',
      classes: 'safety-popup',
      width: 360,
      center: true,
      title: '实名认证',
      content: _realNameTmpl,
      appendCallback: function ($popup) {
        MM.ui.component.renderFormSelect({
          $wrapper: '.ui-form-item.user-card-type',
          placeholder: '证件类型',
          name: 'id_card_type',
          options: {
            1: '大陆身份证',
            2: '护照',
          },
        });
        _handleRealName($popup);
      },
    };

    MM.ui.popup.show(options);
  }

  function _handleRealName($popup) {
    var $errorTip = $popup.find('.error-tip');
    var huzhao = /^1[45][0-9]{7}|G[0-9]{8}|P[0-9]{7}|S[0-9]{7,8}|D[0-9]+$/,
      ID = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;
    var realName = /^\d+$/;
    var errorTips = {
      30402: '当前密码填写错误',
      30411: '密码需同时包含小写字母，大写字母和数字',
      30250: '这是一个bug，反正我是信了', //测试主播改密码
    };

    $popup
      .delegate('input', 'focus', function (e) {
        $errorTip.text('');
      })
      .delegate('.ui-form-btn', 'click', function (e) {
        var data = $.serializeForm($popup);
        var regTest;
        var tipText = '';

        if (data.id_card_type == '1') {
          regTest = ID;
        } else if (data.id_card_type == '2') {
          regTest = huzhao;
        }

        if (!data.real_name.length) {
          tipText = '请输入姓名';
        } else if (!data.id_card_type) {
          tipText = '请选择证件类型';
        } else if (!data.id_card_num.length) {
          tipText = '请输入证件号码';
        } else if (realName.test(data.real_name.toString())) {
          tipText = '真实姓名有误';
        } else if (!regTest.test(data.id_card_num)) {
          tipText = '证件号码有误';
        }

        if (tipText) {
          return $errorTip.text(tipText);
        }

        MM.core.getResult({
          url: _actions.realname,
          requireToken: true,
          data: data,
          success: function (res) {
            MM.ui.popup.showSuccess({
              title: '实名认证',
              tipTitle: '认证成功!',
              okBtnText: '确定',
              duration: 2000,
              callback: function () {
                location.reload();
              },
            });
          },
          resolveError: function (res) {
            $errorTip.text('稍后再试！');
          },
        });
      });
  }

  /**
   * 显示改名弹框
   * @param {Object} options 弹框参数
   * @param {String} url 请求地址
   * @param {Number} coin  柠檬数量
   * @param {Function} callback 回调函数
   */
  function _showCheckRenamingPopup(options) {
    var callback = options.callback;
    var url = options.url;
    var coin = options.coin;
    var showEdit = options.showEdit;
    var text = options.text;
    var isShow = false;

    var error = function () {
      callback && callback(coin, text);
    };

    var success = function (res) {
      // {
      //     "nickname_flag": 0,  // 修改昵称风控 1 禁止修改  2 可修改  3 人工审核
      //     "first_modify": 1,  新用户首次修改昵称 0 未使用  1 已使用
      //     "month_count": 0,  每月1次免费机会  0 未使用  1 已使用
      //     "card_count": 0,   改名卡剩余个数
      //     "pay_coin": 800,   改名需要花费的柠檬币
      //     "exec": 5
      // }
      if (res.data.nickname_flag === 1) {
        MM.ui.popup.hide();
        MM.ui.messager.warn('昵称暂不可修改');
        return;
      }

      if (!res.data.first_modify || !res.data.month_count) {
        MM.ui.popup.hide();
        callback && callback(0, text);
        return;
      }

      if (res.data.first_modify && res.data.month_count && res.data.card_count > 0) {
        MM.ui.popup.show({
          width: 350,
          height: 'auto',
          newUi: true,
          center: true,
          content:
            '<div class="text-center">本次修改将消耗1张改名卡</div><div style="margin-top:60px;" class="ui-form-btn">确定</div>',
          appendCallback: function ($popuWrapper) {
            $popuWrapper.find('.ui-form-btn').on('click', function () {
              MM.ui.popup.hide();
              callback && callback(0, text);
            });
          },
        });
        return;
      }

      coin = parseInt(res.data.pay_coin, 10);

      if (coin) {
        MM.ui.popup.show({
          id: 'confirm-popup',
          width: 400,
          height: 'auto',
          center: true,
          newUi: true,
          content:
            '<div class="text-center">本地修改将消耗' +
            coin +
            '柠檬币</div><div style="margin-top:60px;" class="ui-form-btn">确定</div>',
          closeCallback: function () {
            if (!$('#edit-popup').length && showEdit && !isShow) {
              isShow = true;
              showEdit();
            }
          },
          appendCallback: function ($popuWrapper) {
            $popuWrapper.find('.ui-form-btn').on('click', function () {
              callback && callback(coin, text);
              isShow = true;
              MM.ui.popup.hide();
            });
          },
        });
      } else {
        callback && callback(coin, text);
      }
    };

    request.get(url, success, error);
  }

  /**
   * 获取用户修改密码的 提示信息
   */
  var _renameTip = '';
  function _getRenameTip(callback) {
    if (_renameTip || _renameTip === false) {
      callback && callback(_renameTip);
      return;
    }
    MM.util.flint.getField('meme/public', 'renaming.tips', function (res) {
      _renameTip = _.get(res, 'value') || '';
      callback && callback(_renameTip);
    });
  }

  var userExtra = {
    extraInit: _init,
    getFrom: _getFrom,
    getSubFrom: _getSubFrom,
    redirectToLogin: _redirectToLogin,
    redirectToApply: _redirectToApply,
    redirectToCharge: _redirectToCharge,
    checkUserName: _checkUserName,
    checkNameRepeat: _checkNameRepeat,
    checkPwd: _checkPwd,
    checkConfirmPwd: _checkConfirmPwd,
    sendLoginLog: _sendLoginLog,
    showCommonCheckMobile: _showCommonCheckMobile,
    checkMobileRepeat: _checkMobileRepeat,
    checkMobileNum: _checkMobileNum,
    checkCodeNum: _checkCodeNum,
    mobileReg: _mobileReg,
    popupBindEmail: _popupBindEmail,
    showBindMobilePopup: _showBindMobilePopup,
    handleRealNamePopup: _handleRealNamePopup,
    showCheckRenamingPopup: _showCheckRenamingPopup,
    getRenameTip: _getRenameTip,
  };

  $.extend(MM.user, userExtra);
  return userExtra;
});
